import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Punnisher,
  voices: {
    main: {
      description:
        "grim gravel baritone, deadpan vigilante severity, clipped noir delivery, dry close mic, every line lands like a final warning",
      seed: 10829,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "I'm not a hero, I'm the Punnisher." },
      { id: "select_2", text: "They call me the Punnisher." },
      { id: "select_3", text: "Frank Castle, reporting for duty." },
      { id: "select_4", text: "Castle here." },
      { id: "select_5", text: "Me against an undead army? I like those odds." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Doing this solo? Good thing I brought extra firepower!",
      },
      {
        id: "spawn_2",
        text: "All right, you filthy space rodent. Let's amp it up!",
      },
      { id: "spawn_3", text: "Hmph. Well, at least the Beast's got my back." },
      { id: "spawn_4", text: "Nothing like having the devil on your side!" },
      {
        id: "spawn_5",
        text: "When I find whoever did this to the world, that will be a bad day for them.",
      },
      {
        id: "spawn_6",
        text: "I've seen a lot of stuff I never signed up for in Special Forces.",
      },
      { id: "spawn_7", text: "Different battlefield, same war." },
      { id: "spawn_8", text: "I'll make them pay." },
      { id: "spawn_9", text: "Anything that increases my firepower, I like." },
      {
        id: "spawn_10",
        text: "A bad guy is a bad guy. No real difference between any of 'em.",
      },
      {
        id: "spawn_11",
        text: "Timestream Entanglement? What the hell does that mean?",
      },
      { id: "spawn_12", text: "I like the future. It has kickass ordnance." },
      { id: "spawn_13", text: "Two Dooms, huh? Target-rich environment." },
      {
        id: "spawn_14",
        text: "Someone should have stopped Doom a long time ago.",
      },
      { id: "spawn_15", text: "Right is right and wrong is wrong." },
      { id: "spawn_16", text: "You hurt people, I hurt you." },
      { id: "spawn_17", text: "Only cowards see shades of gray." },
      {
        id: "spawn_18",
        text: "I'll fight this war against crime until I fall.",
      },
      {
        id: "spawn_19",
        text: "Weapons are tools. And I'm the master craftsman.",
      },
      { id: "spawn_20", text: "I'm a blunt instrument. That's how I like it." },
      { id: "spawn_21", text: "You know a word I don't like? Nuance." },
      { id: "spawn_22", text: "I was made for this mission!" },
      { id: "spawn_23", text: "I ain't holdin' back. Not anymore." },
      { id: "spawn_24", text: "Time to make the undead dead again." },
      { id: "spawn_25", text: "Zombies. All the carnage. None of the guilt." },
      {
        id: "spawn_26",
        text: "When I'm done with that witch, there won't be nothin' left.",
      },
      {
        id: "spawn_27",
        text: "Got an endless supply of ammo with Wanda's name on it.",
      },
      { id: "spawn_28", text: "Shoulda stocked up on silver bullets…" },
      { id: "spawn_29", text: "We know the mission. Let's move!" },
      { id: "spawn_30", text: "Let's see how immortal Dracula really is…" },
      {
        id: "spawn_31",
        text: "Gonna send that fanged freak straight back to his grave.",
      },
      {
        id: "spawn_32",
        text: "Been savin' a bullet with your name on it, Fisk!",
      },
      { id: "spawn_33", text: "Can’t wait to finally put you down, Fisk." },
    ],
    respawn: [
      { id: "respawn_1", text: "Now I'm getting mad." },
      { id: "respawn_2", text: "This is not over." },
      { id: "respawn_3", text: "They ain't seen nothing yet." },
      { id: "respawn_4", text: "I'll meet my family, but not today!" },
      { id: "respawn_5", text: "I'm not done yet." },
      { id: "respawn_6", text: "Back for another tour." },
      { id: "respawn_7", text: "Extended my deployment." },
      { id: "respawn_8", text: "I re-upped." },
    ],
    ult_ally: [{ id: "ult_ally", text: "I'm doing this MY WAY!!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Judge, jury…EXECUTIONER!!!" }],
    secondary: [
      { id: "secondary_1", text: "Smokescreen!" },
      { id: "secondary_2", text: "Outta sight!" },
      { id: "secondary_3", text: "Smoke up!" },
    ],
    ability2: [
      { id: "ability2_1", text: "Need some ranged firepower." },
      { id: "ability2_2", text: "I'm hunkering down." },
      { id: "ability2_3", text: "Heavy weapons. I'm in love." },
    ],
    kill: [
      { id: "kill_1", text: "Another bump in the road." },
      { id: "kill_2", text: "You made your last mistake." },
      { id: "kill_3", text: "So weak." },
      { id: "kill_4", text: "Bad choices have bad consequences." },
      { id: "kill_5", text: "Justice, pure and simple." },
      { id: "kill_6", text: "New entry in the War Journal." },
      { id: "kill_7", text: "Down and out." },
      { id: "kill_8", text: "More scum scraped off." },
    ],
    multikill: [
      { id: "multikill_1", text: "Got a little run going." },
      { id: "multikill_2", text: "Gotta keep it up." },
      { id: "multikill_3", text: "Three's a start." },
      { id: "multikill_4", text: "Knockin' 'em down." },
      { id: "multikill_5", text: "Five down." },
      { id: "multikill_6", text: "That's a full fist." },
      {
        id: "multikill_7",
        text: "Maybe the rest of you oughtta shoot faster.",
      },
      { id: "multikill_8", text: "I don't have time to wait for you." },
      { id: "multikill_9", text: "Set 'em up, knock 'em down." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "I'm shipshape." },
      { id: "low_hp_2", text: "Out of the infirmary." },
    ],
    healed: [
      { id: "healed_1", text: "I'm good to go." },
      { id: "healed_2", text: "Battlefield-ready again." },
      { id: "healed_3", text: "Nice little boost." },
      { id: "healed_4", text: "All patched up." },
    ],
  },
} satisfies VoiceScript;

export default script;
